module.exports = __webpack_public_path__ + "img/virtual7.13a28325.png";